import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DialogTitle from '../DialogTitle';
import Dialog from '../Dialog';
import Button from '../../buttons/Button';

const styles = () => ({
  spanSection: {
    display: 'inline-block',
    textAlign: 'center',
    paddingBottom: '1rem',
  },
  buttonsSection: {
    borderTop: '1px solid #F2F2F2',
    paddingTop: '1rem',
    display: 'flex',
    justifyContent: 'space-evenly',
  },
});

const RemoveCustomizationModal = ({
  classes, removeCustomizationModalOpen, toggleRemoveCustomizationModal, onRemoveCustomizedPitch,
}) => (
  <Dialog
    open={removeCustomizationModalOpen}
    size="small"
  >
    <DialogTitle id="dialog-title" disableTypography>
        Remove Customization
    </DialogTitle>
    <span className={classes.spanSection}>
      Are you sure you want to remove customization from this step?
    </span>
    <div className={classes.buttonsSection}>
      <Button color="secondary" variant="text" onClick={toggleRemoveCustomizationModal}>Don’t remove</Button>
      <Button
        color="primary"
        variant="contained"
        className="ml-2"
        onClick={onRemoveCustomizedPitch}
      >
        Yes, remove
      </Button>
    </div>
  </Dialog>
);

RemoveCustomizationModal.propTypes = {
  classes: PropTypes.element.isRequired,
  removeCustomizationModalOpen: PropTypes.bool.isRequired,
  toggleRemoveCustomizationModal: PropTypes.func.isRequired,
  onRemoveCustomizedPitch: PropTypes.func.isRequired,
};

export default withStyles(styles, { withTheme: true })(RemoveCustomizationModal);
